<template>
  <div>
    <portal to="authTitle">
      <h2
        class="mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl"
        id="formlabel"
      >
        {{ title }} your password
      </h2>
      <p class="text-gray-600">
        We will send you an email with a link reset your password
      </p>
    </portal>
    <div id="formio-reset" role="form" aria-labelledby="formlabel"></div>

    <div class="mt-6 text-sm text-center text-gray-600">
      <p>Already have an account?</p>
      <router-link class="text-teal-900 font-semibold" :to="'/sign-in'">
        Log in here?
      </router-link>
    </div>
  </div>
</template>

<script>
import { Formio } from "formiojs";
import tailwind from "@apiabroad/formio-tailwind-template";

export default {
  computed: {
    title() {
      return this.$route.name === "Set Password" ? "Setting" : "Forgot";
    },
  },
  mounted() {
    Formio.use(tailwind);
    Formio.createForm(
      document.getElementById("formio-reset"),
      process.env.VUE_APP_FORMIO_URL + "/advisorresetpasswordmailer",
      {
        hooks: {
          beforeSubmit: async (submission, next) => {
            //check if advisor exists

            if (!(await this.advisorExists(submission.data.email))) {
              next([
                {
                  message:
                    "No account exists for this email address. Please contact your API University Relations team member to create your account.",
                },
              ]);
            } else {
              //Set hide inputs
              submission.data.applicationurl = window.location.origin;
              next();
            }
          },
        },
      }
    ).then((form) => {
      this.$emit("logout");

      form.on("submitDone", (submission) => {
        this.$emit("setEmail", submission.data.email);
        this.$emit("changeComponent", "reset-confirmation");
      });
    });
  },
  methods: {
    advisorExists(email) {
      return fetch(
        process.env.VUE_APP_FORMIO_URL + "/advisor/exists?data.email=" + email
      )
        .then((response) => response.status === 200)
        .catch(() => {
          return false;
        });
    },
  },
};
</script>
